import styled from 'styled-components';

export const Container = styled.div`
  svg {
    height: 100%;
  }
`;

export const LegendSpan = styled.span`
  color: #1a1a32;
  font-size: 14px;
  font-family: 'BiotifMedium';
`;

export const TooltipBox = styled.div`
  color: #1a1a32;
  font-size: 14px;
  font-family: 'BiotifMedium';
  width: 100%;
  display: flex;
  padding: 8px 20px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 16px #00000029;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  gap: 16px;
  max-height: 40px;
`;
